import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import TabContext from '../TabContext';

import styles from './TabPanel.scss';

function TabPanel(props) {
    const {
        className,
        children,
        id,
    } = props;

    return (
        <TabContext.Consumer>
            {({ activeId }) => (
                <div
                    aria-hidden={activeId !== id}
                    aria-labelledby={`tab-${id}`}
                    className={classNames(
                        className,
                        styles.panel,
                        { [styles.active]: activeId === id },
                    )}
                    id={`panel-${id}`}
                    role="tabpanel"
                >
                    {children}
                </div>
            )}
        </TabContext.Consumer>
    );
}

TabPanel.propTypes = {
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
};

export default TabPanel;
